// extracted by mini-css-extract-plugin
export default {"container":"SH6mnYkhF56vrlcqwF8J","divider":"hV7Dkgny4759eE1xRSUR"};